// store/modules/site.js
import { getSiteSettingsAPI } from '@/api/siteSettings'

// 开启命名空间，这样在 dispatch 或 mapState 时就需要使用 'site/xxx'
export const namespaced = true

// 状态
export const state = () => ({
  // 存储从后端获取的站点信息对象
  siteInfo: null,
  // 跟踪初始加载状态
  isLoading: false
})

// 修改状态
export const mutations = {
  /**
   * @description 设置站点信息
   * @param {object} payload - 站点信息对象
   */
  SET_SITE_INFO(state, payload) {
    state.siteInfo = payload
  },
  /**
   * @description 设置加载状态
   * @param {boolean} status - 加载状态
   */
  SET_LOADING(state, status) {
    state.isLoading = status
  }
}

// 异步操作
export const actions = {
  /**
   * @description 异步获取站点配置
   * @param {object} context - Vuex context (包含 commit, state 等)
   * @param {object} params - 参数对象
   * @param {string} params.domain - 当前域名
   */
  async fetchSiteSettings({ commit }, { domain }) {
    // 1. 开始加载
    commit('SET_LOADING', true)
    
    try {
      // 2. 调用 API
      // (假设您的 request 拦截器会自动处理 res.data)
      const res = await getSiteSettingsAPI(domain)

      // 3. 检查后端返回的 code (根据您后端的 ResponseModel)
      if (res.code === 200 && res.data) {
        // 4. 提交 mutation，更新 state
        commit('SET_SITE_INFO', res.data)
        // 返回成功的数据
        return Promise.resolve(res.data)
      } else {
        // API 业务逻辑错误
        console.error('获取站点配置失败:', res.msg)
        commit('SET_SITE_INFO', null) // 出错时清空
        return Promise.reject(new Error(res.msg || '获取配置失败'))
      }
    } catch (error) {
      // 5. 处理网络或JS异常
      console.error('API请求异常(fetchSiteSettings):', error)
      commit('SET_SITE_INFO', null) // 出错时清空
      return Promise.reject(error)
    } finally {
      // 6. 结束加载
      commit('SET_LOADING', false)
    }
  }
}

// 快捷访问
export const getters = {
  // 获取站点信息
  getSiteInfo: (state) => state.siteInfo,
  // 获取加载状态
  getIsLoading: (state) => state.isLoading,
  // (示例) 快捷获取站点标题
  getSiteTitle: (state) => {
    return state.siteInfo ? state.siteInfo.site_title : '站点加载中...'
  }
}